<template>
    <vue-good-table
        styleClass="vgt-table bordered"
        theme="polar-bear"
        :line-numbers="true"
        :columns="columns"
        :rows="data"
        :search-options="{
            enabled: true,
            externalQuery: searchTerm
        }"
        :pagination-options="{
            enabled: true,
            perPage:pageLength
        }"
        class="cargo-details mb-50"
    >
        <template
            slot="table-row"
            slot-scope="props"
        >
            <span v-if="props.column.field === 'description'">
                <p class="column-desc">{{ props.row.cargoDescription }}</p>
            </span>
        </template>
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import {
  BPagination,
  BFormSelect,
} from "bootstrap-vue";
export default {
    name: "CargoDetails",
    components: {
        VueGoodTable,
        BPagination,
        BFormSelect,
    },
    props: {
        data: Array
    },
    data() {
        return {
            pageLength: 3,
            rows: [],
            searchTerm: '',
            columns: [
                {
                    width: "190px",
                    label: "Number of packages",
                    field: 'packagesNumber',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "170px",
                    label: "Kind of packages",
                    field: 'packagesKind',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "400px",
                    label: "Cargo description",
                    field: 'description',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "130px",
                    label: "HS Code",
                    field: 'HSCode',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "210px",
                    label: "Weight of Merchandise",
                    field: 'merchandiseWeight',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "130px",
                    label: "Seal number",
                    field: 'sealNumber',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "150px",
                    label: "Containers liste",
                    field: 'container',
                    filterOptions: {
                        enabled: true,
                        placeholder: ""
                    },
                },
                {
                    width: "180px",
                    label: "Container Quantity",
                    field: 'quantity',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    width: "170px",
                    label: "Container number",
                    field: "containerNumber",
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                }
            ]
        }
    }
}
</script>

<style>
.cargo-details .vgt-table.polar-bear td {
  text-align: center;
  vertical-align: middle !important;
}
.column-desc {
    padding-left: 10px;
    text-align: left !important;
    max-height: 120px;
    overflow-y: auto;
    margin-bottom : 0 !important
}
</style>